<template>
  <div class="home">
    <!-- Banner组件 -->
    <div id="banner-section" class="home-banner">
      <Banner :banners="bannerData" />
    </div>
    <div class="home-product">
      <!-- <h1>{{ $t("product.title") }}</h1> -->
      <div
        class="product-card-container"
        v-for="product in products"
        :key="product.id"
      >
        <ProductCard :product="product" @learn-more="handleLearnMore" />
      </div>
    </div>
    <div id="profile" class="home-container-content">
      <div class="home-container-content-item">
        <ContainerCom :contentId="'2'" backgroundSize="cover" backgroundPosition="center">
          <div class="home-container-content-item-right">
            <div>
              <TextCom :contentId="'3'" />
            </div>
            <div style="margin-bottom: 1vw;">
              <TextCom :contentId="'4'" />
            </div>

            <TextCom :contentId="'5'" />
            <ButtonCom class="button-group" :contentId="'6'" />
          </div>
        </ContainerCom>
      </div>
      <div class="home-container-content-item">
        <ContainerCom :contentId="'1'" backgroundSize="cover" backgroundPosition="center" :allowFullScreenPlay="false"> </ContainerCom>
      </div>
    </div>
    <div id="team" class="home-container-content">
      <div class="home-container-content-item">
        <ContainerCom :contentId="'8'" backgroundSize="cover" backgroundPosition="center" :allowFullScreenPlay="false"> </ContainerCom>
      </div>
      <div class="home-container-content-item">
        <ContainerCom :contentId="'9'" backgroundSize="cover" backgroundPosition="center">
          <div class="home-container-content-item-right2">
            <div>
              <TextCom :contentId="'10'" />
            </div>
            <div>
              <TextCom :contentId="'11'" />
            </div>

            <TextCom :contentId="'12'" />
            <ButtonCom class="button-group" :contentId="'13'" />
          </div>
        </ContainerCom>
      </div>
    </div>

    <!-- <TextCom
        :contentId="'7'"
      /> -->

    <div>
      <!-- 其他组件 -->
      <Technology id="technology" />
      <!-- 其他组件 -->
      <CooperationCases id="cases" />
    </div>
  </div>
</template>

<script>
import api from "../api";
import Banner from "../components/Banner.vue";
import TextCom from "../components/TextCom.vue";
import ContainerCom from "../components/ContainerCom.vue";
import ButtonCom from "../components/ButtonCom.vue";
import ProductCard from "../components/ProductCard.vue";
import Technology from "../components/Technology.vue";
import ContactFloat from "../components/ContactFloat.vue";
import CooperationCases from "../components/CooperationCases.vue";
import { useRoute } from "vue-router";
import { inject } from "vue";

export default {
  name: "Home",
  components: {
    Banner,
    TextCom,
    ContainerCom,
    ButtonCom,
    ProductCard,
    Technology,
    ContactFloat,
    CooperationCases,
  },
  setup() {
    // 获取路由实例
    const route = useRoute();
    // 从父组件注入products
    const products = inject("products", []);
    return { route, products };
  },
  data() {
    return {
      pageConfig: {
        title: "",
        content: "",
      },
      bannerData: [],
    };
  },
  mounted() {
    // 只获取Banner数据
    this.getBanners();
    // 检查URL中的hash并滚动到相应位置
    this.handleHashNavigation();
    // 监听hash变化
    // window.addEventListener('hashchange', this.handleHashNavigation);
    // // 监听路由变化，确保在路由切换后也能处理hash
    this.$router.afterEach(() => {
      this.handleHashNavigation();
    });
  },
  beforeUnmount() {
    // 移除事件监听器
    // window.removeEventListener('hashchange', this.handleHashNavigation);
    // 移除路由监听器
    // if (this.routerGuard) {
    //   this.routerGuard();
    // }
  },
  methods: {
    handleHashNavigation() {
      const hash = this.$route.path;
      // 延迟执行以确保DOM已经渲染完成
      setTimeout(() => {
        if (hash) {
          // 移除hash前缀(#)
          const targetId = hash.substring(1);
          // 查找目标元素
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            // 平滑滚动到目标元素
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          } else {
            console.log(`未找到ID为${targetId}的元素`);
          }
        }
      }, 100);
    },
    // 判断是否是视频格式
    isVideoFormat(url) {
      const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv"];
      const extension = url.split(".").pop().toLowerCase();
      return videoExtensions.includes(extension);
    },
    // 获取Banner数据
    async getBanners() {
      try {
        const response = await api.banner.getBannerList({
          page: 1,
          limit: 10,
          isActive: 1,
          // 可以添加筛选条件，比如只获取启用的banner
        });
        if (response.success && response.data && response.data.list) {
          // 将后端返回的数据格式转换为Banner组件所需的格式
          this.bannerData = response.data.list // 只显示启用的banner
            .sort((a, b) => (a.orderNum || 0) - (b.orderNum || 0)) // 按排序号排序
            .map((banner) => ({
              // 根据bannerUrl中的文件扩展名判断是否为视频
              type: this.isVideoFormat(banner.bannerUrl) ? "video" : "image",
              src: banner.bannerUrl,
              alt: `Banner ${banner.id}`,
              title: banner.title || "",
              linkUrl: banner.linkUrl || "",
            }));
        }
      } catch (error) {
        console.error(this.$t("banner.errors.fetchFailed"), error);
      }
    },
  },
};
</script>

<style scoped>
.home-container-content {
  display: grid;
  /* 使用minmax确保列有最小宽度，auto-fit会自动调整列数 */
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  /* 在大屏幕上设置两列布局 */
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  grid-auto-rows: 1fr;
  align-items: stretch;
}
.home-banner {
  height: 100vh;
  @media (max-width: 768px) {
    height: 80vh;
  }
}
.home-container-content-item {
  /* 网格布局中不需要设置宽度，由grid-template-columns控制 */
  min-width: 300px;
  min-height: 500px;
  /* 确保填充整个网格单元格高度 */
  height: 100%;
  display: flex;
  flex-direction: column;
}

.button-group {
  margin-top: 20px;
  display: flex;
  gap: 15px;
}
.home-container-content-item-right {
  padding: 15% 20% 20% 10%;
  text-align: left;
}
@media (max-width: 768px) {
  .home-container-content-item-right {
    padding: 10%;
    text-align: left;
  }
}
.home-container-content-item-right2 {
  padding: 5% 10%;
  text-align: left;
}
@media (max-width: 768px) {
  .home-container-content-item-right2 {
    padding: 5%;
    text-align: left;
  }
}
.button-group {
  margin-top: 40px;
}
.home-product {
  /* background-color: #f1f6fa; */
  background-color: #fff;
  text-align: center;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  padding: 60px 120px;
  gap: 40px;
  justify-items: center;
}
h1 {
  color: #333;
  text-align: center;
  margin: 2rem auto 1rem;
  width: 100%;
}
.product-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

/* 中屏幕适配（769px - 1100px） */
@media (min-width: 769px) and (max-width: 1100px) {
  .home-product {
    grid-template-columns: 1fr;
    padding: 20px 60px;
  }
}

/* 小屏幕适配（小于等于768px） */
@media (max-width: 768px) {
  .home-product {
    grid-template-columns: 1fr;
    padding: 20px 20px;
  }
}
</style>
